import Carrossel from "./../../components/Carrossel"
import Article from "../../components/main/Article"
import Section from "../../components/Section/"
import BannerF from "./../../components/Bannerf"

export default function Home(){
    return(
        <div>
            <Carrossel />
            <Article/>
            <Section/>
            <BannerF/>

    </div>
    )
}